import { loadGoogleMaps } from './googleMapsLoader';

const cache = new Map<string, Promise<number | null>>();

/** Shared by Itinerary and Schedule, so one route lookup yields the same ETA in both views. */
export function fetchDrivingDuration(from: string, to: string): Promise<number | null> {
  const key = JSON.stringify([from, to]);
  const cached = cache.get(key);
  if (cached) return cached;
  const request = (async () => {
    try {
      await loadGoogleMaps();
      const maps = window.google?.maps;
      if (!maps?.DirectionsService) return null;
      const result = await new Promise<any>(resolve => new maps.DirectionsService().route(
        { origin: from, destination: to, travelMode: 'DRIVING' },
        (route: any, status: string) => resolve(status === maps.DirectionsStatus.OK ? route : null),
      ));
      const seconds = result?.routes?.[0]?.legs?.[0]?.duration?.value;
      return typeof seconds === 'number' && seconds > 0 ? Math.max(1, Math.round(seconds / 60)) : null;
    } catch {
      return null;
    }
  })();
  cache.set(key, request);
  request.then(minutes => {
    if (minutes === null) setTimeout(() => {
      if (cache.get(key) === request) cache.delete(key);
    }, 60_000);
  });
  return request;
}
